import "/acf-blocks/block-image-stats/block-image-stats.scss"
import { Flickity } from '../../src/shared'
import '../../node_modules/flickity/dist/flickity.min.css'
import '../../node_modules/flickity-fade/flickity-fade.css'
import '../../node_modules/flickity-fade/flickity-fade.js'

class ImageStatsTabs {
  constructor(container) {
    this.container = container
    this.tabButtons = this.container.querySelectorAll('.js-tab-button')
    this.tabsContent = this.container.querySelector('.block-image-stats__tabs-content')
    this.tabPanels = this.container.querySelectorAll('.js-tab-panel')
    this.tabsList = this.container.querySelector('.block-image-stats__tabs-nav ul')
    this.init()
  }

  init() {
    // Create and insert the sliding indicator
    this.createIndicator()

    this.tabButtons.forEach(button => {
      button.addEventListener('click', this.handleTabClick.bind(this))
    })

    // Set initial height
    this.setContainerHeight()

    // Position indicator on the active tab without transition
    this.updateIndicator(false)

    // Enable transitions after initial positioning
    setTimeout(() => {
      if (this.indicator) {
        this.indicator.style.transition = 'transform 0.3s ease, width 0.3s ease'
      }
    }, 0)

    // Update height and indicator on window resize
    window.addEventListener('resize', () => {
      this.setContainerHeight()
      this.updateIndicator()
    })
  }

  createIndicator() {
    if (!this.tabsList) return

    this.indicator = document.createElement('div')
    this.indicator.className = 'block-image-stats__tabs-indicator'
    this.tabsList.insertBefore(this.indicator, this.tabsList.firstChild)
  }

  updateIndicator() {
    if (!this.indicator) return

    const activeButton = this.container.querySelector('.js-tab-button.is-active')
    if (!activeButton) return

    const buttonRect = activeButton.getBoundingClientRect()
    const listRect = this.tabsList.getBoundingClientRect()

    const offsetLeft = buttonRect.left - listRect.left
    const width = buttonRect.width

    this.indicator.style.transform = `translateX(${offsetLeft}px)`
    this.indicator.style.width = `${width}px`
  }

  setContainerHeight() {
    if (!this.tabsContent || this.tabPanels.length === 0) return

    let maxHeight = 0

    // Find the tallest panel
    this.tabPanels.forEach(panel => {
      // Calculate height by summing specific child elements
      const carousel = panel.querySelector('.js-stats-carousel')
      const image = panel.querySelector('.js-stats-image')
      
      let panelHeight = 0
      if (carousel) {
        panelHeight += carousel.offsetHeight
      }
      if (image) {
        panelHeight += image.offsetHeight
      }

      if (panelHeight > maxHeight) {
        maxHeight = panelHeight
      }
    })

    // Set the container height
    if (maxHeight > 0) {
      this.tabsContent.style.height = `${maxHeight + 10}px`
    }
  }

  handleTabClick(event) {
    const button = event.currentTarget
    const tabIndex = button.getAttribute('data-tab')
    
    if (!this.container) return
    
    // Remove active class from all buttons in this container
    const allButtons = this.container.querySelectorAll('.js-tab-button')
    allButtons.forEach(btn => btn.classList.remove('is-active'))
    
    // Remove active class from all panels in this container
    const allPanels = this.container.querySelectorAll('.js-tab-panel')
    allPanels.forEach(panel => panel.classList.remove('is-active'))
    
    // Add active class to clicked button
    button.classList.add('is-active')
    
    // Update the sliding indicator position
    this.updateIndicator()
    
    // Add active class to corresponding panel
    const targetPanel = this.container.querySelector(`.js-tab-panel[data-tab-panel="${tabIndex}"]`)
    if (targetPanel) {
      targetPanel.classList.add('is-active')
    }
  }
}

class StatsCarousel {
  constructor() {
    this.carousels = document.querySelectorAll('.js-stats-carousel')
    this.flickityInstances = []
    this.init()
  }

  isMobile() {
    return window.innerWidth <= 768
  }

  init() {
    if (!this.carousels.length) return

    this.carousels.forEach((carousel) => {
      const isMobile = this.isMobile()
      
      const flkty = new Flickity(carousel, {
        cellAlign: 'left',
        contain: true,
        pageDots: isMobile,
        prevNextButtons: false,
        cellSelector: '.carousel-cell',
        wrapAround: true,
        autoPlay: isMobile ? 3000 : false,
        groupCells: !isMobile,
        draggable: isMobile,
        dragThreshold: 10,
        fade: isMobile,
        friction: 0.7,
        selectedAttraction: 0.01, 
        on: {
          ready: () => {
            window.dispatchEvent(new Event('resize'))
          }
        }
      })

      this.flickityInstances.push(flkty)

      const handleResize = () => {
        const shouldBeMobile = this.isMobile()
        let needsUpdate = false

        if (flkty.options.draggable !== shouldBeMobile) {
          flkty.options.draggable = shouldBeMobile
          needsUpdate = true
        }

        if (flkty.options.fade !== shouldBeMobile) {
          flkty.options.fade = shouldBeMobile
          needsUpdate = true
        }

        if (flkty.options.groupCells !== !shouldBeMobile) {
          flkty.options.groupCells = !shouldBeMobile
          needsUpdate = true
        }

        if (needsUpdate) {
          flkty.updateDraggable()
          flkty.deactivate()
          
          // Re-initialize with updated options
          flkty.options.pageDots = shouldBeMobile
          flkty.activate()
        }
      }

      window.addEventListener('resize', () => {
        flkty.resize()
        handleResize()
      })

      // Force resize on load to ensure proper positioning
      window.addEventListener('load', () => {
        flkty.resize()
      })
    })
  }
}

// Initialize all image stats tabs on the page
document.addEventListener('DOMContentLoaded', function() {
  const tabContainers = document.querySelectorAll('.block-image-stats__tabs')
  tabContainers.forEach(container => {
    new ImageStatsTabs(container)
  })

  // Initialize stats carousels
  new StatsCarousel()
})